import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Subscribe from './pages/Subscribe';
import Success from './pages/Success';
import Dashboard from './pages/Dashboard';
import Player from './pages/Player';
import TopBar from './components/TopBar';
import LoginPage from './pages/LoginPage';
import { AuthProvider, useAuth } from './hooks/useAuth';
import AdsList from './components/AdsList';
import ScreensList from './components/ScreensList';
import ProductsList from './components/ProductsList';
import UsersList from './components/UsersList';

function PrivateRoute({children}) {
  const { token } = useAuth();
  return token ? children : <Navigate to='/login' />;
}

export default function App(){
  return (
    <BrowserRouter>
      <TopBar />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/pricing" element={<Pricing/>} />
        <Route path="/subscribe" element={<Subscribe/>} />
        <Route path="/success" element={<Success/>} />
        <Route path="/dashboard" element={<Dashboard/>} />
        <Route path="/player" element={<Player/>} />
        <Route path="/login" element={<LoginPage/>} />
        {/* <Route path="/dashboard" element={<PrivateRoute><Dashboard/></PrivateRoute>} /> */}
        <Route path="/ads" element={<AdsList />} />
        <Route path="/screens" element={<ScreensList/>} />
        <Route path="/products" element={<ProductsList/>} />
        <Route path="/users" element={<UsersList/>} />
      </Routes>
    </BrowserRouter>
  );
}
